export default {
    login: {
        authenticated: true,
        error: false
    },
    register: {
        plan: "Basic"
    }
    
}